import { useCallback } from 'react';

import type { PageViewSettingsIContent } from '../../../customTypings/epiBaseModels';
import type { CoopContentPageSize } from '../../../utility/coopSwiperBreakpoints';
import type { EpiSitePageType } from '../../episerver/components/pages/epiSitePageType';

import { useLayoutSize } from '../../common/hooks/useLayoutSize';
import { isEpiPageViewSettings } from '../../episerver/epiUtils';

export const useContentPageSizeSync = () => {
    const { setContentPageSize } = useLayoutSize();
    const handlePageLoad = useCallback(
        (page: EpiSitePageType | PageViewSettingsIContent) => {
            if (isEpiPageViewSettings(page)) {
                setContentPageSize(page.contentPageSize as CoopContentPageSize);
            }
        },
        [setContentPageSize],
    );

    return {
        handlePageLoad,
    };
};
